import { validationsService } from "@/services/validations-api.service";

const SET_CLAIM_PAYMENTS_ENABLED = 'setClaimPaymentsEnabled'
const SET_RUN_PIPELINES_ENABLED = 'setRunPipelinesEnabled'

const state = () => ({
    
});

const getters = {
    
};

const mutations = {
    
};

const actions = {
    runPipelinesForClaim({ commit }, payload) {
        return new Promise((resolve, reject) => {
            validationsService
                .runPipelinesForClaim(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            console.log('-r : ', apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}